import { render } from "./MaterialTable.vue?vue&type=template&id=32a7981d&ts=true"
import script from "./MaterialTable.vue?vue&type=script&lang=ts"
export * from "./MaterialTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__